import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { WebSettings, WebSwoDeliveryRequest } from "../../../../models";
import { CompanyService } from "src/app/services";
import { Router } from "@angular/router";

@Component({
  selector: "app-request-confirmation-dialog",
  templateUrl: "./request-confirmation-dialog.component.html",
  styleUrls: ["./request-confirmation-dialog.component.scss"]
})
export class RequestConfirmationDialogComponent implements OnInit
{

  request: WebSwoDeliveryRequest;
  isPaymentMade: boolean;
  webSettingsSubscription: Subscription;
  webSettings: WebSettings;
  isPriceCalculatorEnabled: boolean;
  isDelivery: boolean;
  areAmountsSentToCompany: boolean;

  date = new Date().toLocaleDateString();

  constructor(
    public dialogRef: MatDialogRef<RequestConfirmationDialogComponent>,
    public dialog: MatDialog,
    public router: Router,
    private companyService: CompanyService,
    @Inject(MAT_DIALOG_DATA) data
  )
  {
    this.request = data.request;
    this.isPaymentMade = data.isPaymentMade;

  }

  ngOnInit(): void
  {
    this.webSettingsSubscription = this.companyService.webSettings.subscribe(w =>
    {
      this.webSettings = w;
      this.isPriceCalculatorEnabled = w.IsPriceCalculatorEnabled ?? false;
      this.areAmountsSentToCompany = w.IsPriceCalculatorAmountsLockEnabled ?? false;
      this.isDelivery = this.request.RequestType == 'Delivery' ? true : false;
    });

  }
  ngOnDestroy(): void
  {
    this.webSettingsSubscription.unsubscribe();
  }

  @HostListener("window:keyup.esc") handleEscapeKey()
  {
    this.handleCloseClick();
  }

  public handleCloseClick(): void
  {
    this.dialog.closeAll();
    this.router.navigate(["/home"]);
  }

}
